<style src="./TrackSearchField.scss" lang="scss"></style>

<template lang="pug">
  .track-search-field(
    :class='{ "is-focused": focused, "is-loading": loading }'
  )
    .track-search-field__control
      .track-search-field__icon
        Icon(
          name='search'
        )
      input.track-search-field__input(
        name='q'
        type='search'
        :placeholder='$l10n("FIND_TRACK")'
        autocomplete='off'
        v-model='keyword'
        @focus='setFocus(true)'
        @blur='setFocus(false)'
        @input='debouncedFetchResults'
        v-shortkey.avoid
      )
    ul.track-search-field__results(
      v-if='findedTracks.length && focused'
    )
      li.track-search-field__result-item(
        v-for='track in findedTracks'
        :key='track.id'
      )
        SearchTrack(
          :track='track'
          :playlist-id='playlistId'
        )

</template>

<script>
import Icon from "@/components/Icon/Icon";

import Helpers from "@/services/helpers";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "TrackSearchField",
  props: {
    playlistId: String
  },
  data() {
    return {
      keyword: "",
      loading: false,
      focused: false,
      debouncedFetchResults: null
    };
  },
  components: {
    Icon,
    SearchTrack: () => import("@/components/SearchTrack/SearchTrack")
  },
  computed: {
    ...mapGetters({
      results: "search/results",
      tracks: "tracks/tracks"
    }),
    findedTracks() {
      return this.results.tracks
        ? this.results.tracks.map(track => this.tracks[track.id])
        : [];
    }
  },
  methods: {
    ...mapActions({
      fetchResults: "search/tracks",
      clearResults: "search/clear"
    }),
    clear() {
      this.clearResults("tracks");
      this.keyword = "";
    },
    setFocus(state) {
      if (state) {
        this.focused = true;
      } else {
        setTimeout(() => {
          this.focused = false;
        }, 200);
      }
    }
  },
  created() {
    this.debouncedFetchResults = Helpers.debounce(() => {
      const timer = setTimeout(() => {
        this.loading = true;
      }, 600);

      this.fetchResults(this.keyword).then(() => {
        clearTimeout(timer);
        setTimeout(() => {
          this.loading = false;
        }, 400);
      });
    }, 200);
  }
};
</script>
